import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormDialog from '../../../library/form/components/FormDialog';
import FormRichText from '../../../library/form/components/FormRichText';
import FormInput from '../../../library/form/components/FormInput';
import FormSH from '../../../library/form/components/FormSH';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormUpload from '../../../library/form/components/FormUpload';
import FormAttachment from '../../../library/form/components/FormAttachment';
import FormLabel from '../../../library/form/components/FormLabel';
import FormTitle from '../../../library/form/components/FormTitle';

//TODO FormLink for attachment;

const DocAttachmentEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '400px', height: '400px' }} formTitle={<FormTitle formObject={formObject} value="Attachment" />}
        >
            <div >
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fileSelector" }} value="File" />
                    </span>
                    <FormUpload formObject={formObject} rowKey="" action={{ actionId: "upload", paramName: "fileSelector", actionName: "mediaManage", actionParam: { rt: 'a' } }} />

                    <FormAttachment formObject={formObject} rowKey="" action={{ InputType: "a", paramName: "fileLink" }} />
                </div>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fileType" }} value="Type" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" id="addressTypeTxt" className="uiInput uiSpacerH5"
                        action={{ InputType: "ac", paramName: "fileType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "4" } }}
                    />

                    <FormSH formObject={formObject} rowKey="" 
                        action={{ actionId: "new", paramName: "fileType",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                    />
                </div>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "shvl" }} value="Share via link" />
                    </span>
                    <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "shvl" }} />
                </div>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "desc" }} value="Remarks" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82"
                        action={{ paramName: "desc" }}
                    />
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(DocAttachmentEditor, "docAttachment", "docAttachment,v5WorkFlow")